import { Space, Typography, Form, InputNumber } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-solid-svg-icons'
import { OwnerStepProps } from '../../types'
import { checkField } from '../../inputSanityModel'
import BandSliderInput from '../BandSliderInput'
import { SLIDER_TRACKS } from '../../bandSliderModel'

const { Title, Paragraph } = Typography

export const OwnerStep = ({ data, onChange }: OwnerStepProps) => {
  const hoursWarning = checkField('ownerHoursPerWeek', data.hoursPerWeek)
  const salaryWarning = checkField('ownerSalary', data.annualSalary, { ownerHoursPerWeek: data.hoursPerWeek })

  return (
    <Space
      direction="vertical"
      size="large"
      style={{
        width: '100%',
        maxWidth: '800px',
        padding: '40px 20px'
      }}
    >
      <div style={{
        backgroundColor: 'white',
        padding: '32px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <Space direction="horizontal" size="middle" style={{ marginBottom: '16px' }}>
          <FontAwesomeIcon icon={faUser} style={{ fontSize: '24px', color: '#ff6b4a' }} />
          <Title level={3} style={{ margin: 0 }}>Owner Details</Title>
        </Space>

        <Paragraph style={{ color: '#666', marginBottom: '32px' }}>
          Enter owner work schedule and compensation.
        </Paragraph>

        <Form layout="vertical">
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Form.Item
              label="How many hours per week does the owner work?"
              required
              style={{ marginBottom: 0 }}
            >
              <BandSliderInput
                value={data.hoursPerWeek}
                onChange={(value) => onChange('hoursPerWeek', value)}
                track={SLIDER_TRACKS.ownerHoursPerWeek}
                unit="number"
                valueSuffix="hours a week"
                placeholder="40"
                helpText="Include all time spent on the business — field work, admin, sales, and estimating"
                warning={hoursWarning}
              />
            </Form.Item>

            <Form.Item
              label="What percentage of their times does the owner work in the field?"
              required
              style={{ marginBottom: 0 }}
            >
              <InputNumber
                suffix="%"
                value={data.fieldWorkPercentage}
                onChange={(value) => onChange('fieldWorkPercentage', value)}
                min={0}
                max={100}
                style={{ width: '300px' }}
                size="large"
              />
            </Form.Item>

            <Form.Item
              label="Owner Annual Salary"
              required
              style={{ marginBottom: 0 }}
            >
              <BandSliderInput
                value={data.annualSalary}
                onChange={(value) => onChange('annualSalary', value)}
                track={SLIDER_TRACKS.ownerSalary}
                unit="dollar"
                valueSuffix="a year"
                placeholder="100,000"
                helpText="Don't forget to include owner draws"
                warning={salaryWarning}
              />
            </Form.Item>
          </Space>
        </Form>
      </div>
    </Space>
  )
}
